import { isMobilePurpleUseragent, makeElement } from "../../../common/Utils";
import { AbsSocial } from "./AbsSocial";
import { ga360 } from "./GA360";

export class Twitter extends AbsSocial {

    name: SocialName = 'twitter'
    dataContents = ga360.dataContents.twitter;
    dataArea = ga360.dataArea.common;

    constructor(protected ElShareItemWrap: HTMLElement, protected option: ShareOption){
        super(ElShareItemWrap, option);

        this.init();
    }

    addEvent(){
        this.ElBtn.addEventListener('click', () => {
            const targetUrl = 'https://twitter.com/intent/tweet?text=' + this.option.shareUrl;

            if(isMobilePurpleUseragent()){
                location.href = `ncmtalk://external?url=${targetUrl}`;
            }else{
                window.open(targetUrl, '_blank');
            }

            // window.open(targetUrl, '_blank');
        })
    }

}
